import { createZodDto } from './zod';

import { z } from 'zod';

const manageSubscriptionDtoSchema = z.object({
  type: z.enum(['manage', 'upgrade', 'cancel']),
  quantity: z.number().min(1).max(20000).optional(),
  planFrequency: z.enum(['MONTHLY', 'YEARLY']).optional(),
});

export class ManageSubscriptionDto extends createZodDto(
  manageSubscriptionDtoSchema,
) {}

type BillingPortalResponse = {
  type: 'portal';
  value: string;
};

type CheckoutResponse = {
  type: 'checkout';
  value: string;
};

export type ManageSubscriptionResponseDto =
  | BillingPortalResponse
  | CheckoutResponse;
